import React from 'react'
import PropTypes from 'prop-types'
import CommsManagerGate from '../../components/CommsManagerGate'

/**
 * Renders `children` only for someone who may change holidays on this host
 * (comms-tool-dev on dev, comms-tool-prod on production); everyone else
 * gets the reason and a way back to the list. The list page hides its
 * buttons with the same rule; this covers a typed or bookmarked link.
 */
const HolidayManagerGate = ({ children }) => (
    <CommsManagerGate
        title="You cannot change holidays here"
        action="Creating and uploading holidays"
        elsewhere="Holidays can only be changed on dev and production."
        backTo="/holidays"
        backLabel="Back to holidays"
    >
        {children}
    </CommsManagerGate>
)

HolidayManagerGate.propTypes = { children: PropTypes.node }

export default HolidayManagerGate
